"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isAiModelEffort = isAiModelEffort;
exports.modelDefaults = modelDefaults;
const model_card_1 = require("./model-card");
const REASONING_EFFORT_ORDER = [
    model_card_1.AiModelEffort.none,
    model_card_1.AiModelEffort.minimal,
    model_card_1.AiModelEffort.low,
    model_card_1.AiModelEffort.medium,
    model_card_1.AiModelEffort.high,
    model_card_1.AiModelEffort.xhigh,
    model_card_1.AiModelEffort.max,
];
function isAiModelEffort(value) {
    return REASONING_EFFORT_ORDER.includes(value);
}
function coerceReasoningValue(parameters, requestedValue) {
    if (requestedValue === undefined || parameters.supportedValues.includes(requestedValue)) {
        return requestedValue ?? parameters.defaultValue;
    }
    if (!isAiModelEffort(requestedValue)) {
        return parameters.defaultValue;
    }
    const requestedIndex = REASONING_EFFORT_ORDER.indexOf(requestedValue);
    const supportedEfforts = parameters.supportedValues.filter(isAiModelEffort);
    return (supportedEfforts.reduce((closest, candidate) => {
        if (!closest) {
            return candidate;
        }
        const candidateIndex = REASONING_EFFORT_ORDER.indexOf(candidate);
        const closestIndex = REASONING_EFFORT_ORDER.indexOf(closest);
        const candidateDistance = Math.abs(candidateIndex - requestedIndex);
        const closestDistance = Math.abs(closestIndex - requestedIndex);
        return (candidateDistance < closestDistance ||
            (candidateDistance === closestDistance && candidateIndex < closestIndex)) ?
            candidate
            : closest;
    }, undefined) ?? parameters.defaultValue);
}
function modelDefaults(card, overrides) {
    const maxResponseTokens = validateMaxResponseTokens(card, overrides?.maxResponseTokens);
    const cap = maxResponseTokens === undefined ? {} : { maxResponseTokens };
    if (!card.reasoning) {
        return { model: card.model, ...cap };
    }
    return {
        model: card.model,
        reasoning: {
            parameter: card.reasoning.parameter,
            value: coerceReasoningValue(card.reasoning, overrides?.reasoning),
        },
        ...cap,
    };
}
function validateMaxResponseTokens(card, requested) {
    if (requested === undefined) {
        return undefined;
    }
    if (!Number.isInteger(requested) || requested <= 0) {
        throw new Error(`ModelDefaults_InvalidMaxResponseTokens:${card.model}:${requested}`);
    }
    if (requested > card.maxOutputTokens) {
        throw new Error(`ModelDefaults_MaxResponseTokensExceedsCard:${card.model}:${requested}>${card.maxOutputTokens}`);
    }
    return requested;
}
//# sourceMappingURL=model-defaults.js.map